import { useState } from 'react'
import { message } from 'antd'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import GenericModal from '../buttons/genericModal'
import StyledButton from '../generic/StyledButton'
import { backendPatchWithoutRefresh } from '../../helpers/callBackend'
import { isClosable } from '../../helpers/isClosable'
import { errorMessage } from '../../helpers/errorMessageFunc'

const CloseBankAccount = (props) => {
  const [modalVisible, setModalVisible] = useState(false)

  const onFormSubmitCloseModal = () => {
    let res = isClosable(props.bankInfo)
    let data = {
      action: 'close_account',
      account_id: props.bankAccountId,
    }
    if (res[0]) {
      backendPatchWithoutRefresh('/api/bank-account/', data).then((response) => {
        message.success(response.data?.description)
        setModalVisible(false)
      })
    } else {
      errorMessage(res[1])
    }
  }

  return (
    <GenericModal
      visible={modalVisible}
      handleCancelModal={() => setModalVisible(false)}
      showModal={() => setModalVisible(true)}
      size='sm'
      button={<>{props.buttonView ? <Button variant='contained'>Close</Button> : <span>Close</span>}</>}
      modalTitle={'Close Bank Account'}
      modalBody={
        <Stack spacing={1}>
          <Typography>Do you really want to close this account?</Typography>
          <Stack direction='row' spacing={2}>
            <StyledButton
              label='No'
              customTheme='outlined'
              onClick={() => this.setState({ ...this.state, visible: false })}
            />
            <StyledButton label='Yes' onClick={onFormSubmitCloseModal} />
          </Stack>
        </Stack>
      }
    />
  )
}
export default CloseBankAccount
